import React, { lazy, Suspense } from 'react';

const LazyAdminWarrantyRegistrationSearch = lazy(() => import('./AdminWarrantyRegistrationSearch'));

const AdminWarrantyRegistrationSearch = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyAdminWarrantyRegistrationSearch {...props} />
  </Suspense>
);

export default AdminWarrantyRegistrationSearch;
